/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import Cookies from 'js-cookie';
import store from '@/store';
import { AccessToken } from '@/classes/api';
import _ from 'underscore';

let jwtToken = null;
let uiСhannel = null;

export default {
  check() {
    return (
      !!localStorage.getItem('$LoopBack$accessTokenId') &&
      !!localStorage.getItem('$LoopBack$currentUserId')
    );
  },
  fetchUser() {
    store.dispatch('user/fetchMyself');
  },
  fetchToken() {
    AccessToken.set(localStorage.getItem('$LoopBack$accessTokenId'));
  },
  getJwtToken() {
    return jwtToken;
  },
  setJwtToken(jwt) {
    jwtToken = jwt;
  },
  getUiСhannel() {
    return uiСhannel;
  },
  setUiСhannel(channel) {
    uiСhannel = channel;
  },
  async tryToLoginByJwt(jwt, uiСhannel = null) {
    if (jwt && jwt.length) this.setJwtToken(jwt);
    if (uiСhannel && uiСhannel.length) this.setUiСhannel(uiСhannel);

    let token = this.getJwtToken();
    let channel = this.getUiСhannel();

    let payload = {};
    if (token) payload.token = token;
    if (channel) payload.channel = channel;

    if (!Object.keys(payload).length) return;
    //auth
    //request ot DA

    // костыль, в старой реализации токен передавался как строка, чтобы в других
    // сервисах не возникла проблема с совместимостью отдаем либо строку, либо объект для частного случая с uiChannel
    // TODO: привести нагрузку экшена к общему типу в разных фронтовых модулях
    try {
      let res;
      if (uiСhannel) res = await store.dispatch('user/logIn', payload);
      else {
        res = await store.dispatch('user/logIn', token);
      }
      // let { user, token } = await store.dispatch('user/logIn');
      this.setLocalData(res.data.id, res.data.user.id, 'jwt');
    } catch (e) {
      throw e;
    }
  },
  clearLocalData() {
    localStorage.removeItem('$LoopBack$accessTokenId');
    localStorage.removeItem('$LoopBack$currentUserId');
    localStorage.removeItem('$LoopBack$rememberMe');
    localStorage.removeItem('$loginType');
  },
  setLocalData(token, userId, loginType) {
    localStorage.setItem('$LoopBack$accessTokenId', token);
    localStorage.setItem('$LoopBack$currentUserId', userId);
    localStorage.setItem('$LoopBack$rememberMe', false);
    localStorage.setItem('$loginType', loginType);
  },
  getToken() {
    return this.check() ? localStorage.getItem('$LoopBack$accessTokenId', null) : null;
  },
  getUserId() {
    return this.check() ? localStorage.getItem('$LoopBack$currentUserId', null) : null;
  },
  getLoginType() {
    return this.check() ? localStorage.getItem('$loginType', null) : null;
  },

  checkCookie() {
    return !!Cookies.get('quid') && !!Cookies.get('qat');
  },
  checkCookieLoginType() {
    return !!Cookies.get('loginType');
  },
  clearCookieData() {
    Cookies.remove('qat');
    Cookies.remove('quid');
    Cookies.remove('loginType');
    Cookies.remove('app.guest.username');
    // for old login
    this.clearLocalData();
  },
  getCookieToken() {
    return this.checkCookie() ? Cookies.get('qat') : null;
  },
  getCookieUserId() {
    return this.checkCookie() ? Cookies.get('quid') : null;
  },
  getCookieLoginType() {
    return this.checkCookieLoginType() ? Cookies.get('loginType') : '';
  },
  setLocalDataFromCookie() {
    const userId = this.getCookieUserId().substr(2).split('.')[0];
    const token = this.getCookieToken().substr(2).split('.')[0];
    const loginType = this.getCookieLoginType().substr(2).split('.')[0];
    this.setLocalData(token, userId, loginType);
  },
  isInRoles(userRoles, expectedRoles) {
    // console.log('isInRoles');
    if (userRoles && expectedRoles && userRoles.length > 0 && expectedRoles.length > 0) {
      for (let i = 0; i < userRoles.length; i++) {
        if (_.indexOf(expectedRoles, userRoles[i].name) >= 0) {
          return true;
        }
      }
    }
    return false;
  },
  async logout(Vue, returnSubLink) {
    try {
    	// common logout method for all front components
      await store.dispatch('user/userLogout', {});
      if (window.$socket)
        window.$socket.emit('logout', localStorage.getItem('$LoopBack$accessTokenId'));
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}`;
      const return_to = !!returnSubLink ? link + returnSubLink : link;
      sessionStorage.setItem('return_to', return_to); // window.location.href
      this.clearCookieData();
      window.location = `${link}/login/#/logout`;
    } catch (e) {
      Vue.prototype.$toastr(
        'error',
        Vue.prototype.$t('Something went wrong. Please try again later')
      );
      throw e;
    }
  },
};
